"use client" // Error components must be Client Components

import { Image, Text, Title, Button, Center } from "@mantine/core"
import { IconHome } from "@tabler/icons-react"
import { useEffect } from "react"

import classes from "./not-found.module.css"
import { usePathname } from "next/navigation"
import Link from "next/link"

export default function NotFoundPage() {
  const pathname = usePathname()
  useEffect(() => {
    document.title = "Page not found! - Ring.io"
    // Log the error to an error reporting service
    console.error(`Page not found: ${pathname}`)
  }, [pathname])

  return (
    <Center className={classes.container}>
      <div className={classes.imageContainer}>
        <Title className={classes.errorCode}>404</Title>
        <Image alt="Not Found Logo" h={300} w="auto" fit="contain" src="/assets/error_404.gif" className={classes.image} />
      </div>
      <div className={classes.textContainer}>
        <Title order={3} className={classes.title}>
          Looks like you&apos;re lost!
        </Title>
        <Text className={classes.text} maw={560}>
          The page you are looking for does not exist. How you got here is a mystery. But you can click the button below to go back to the homepage.
        </Text>
        <Button size={"md"} leftSection={<IconHome size={16} />} component={Link} href="/" className={classes.button}>
          Go home
        </Button>
      </div>
    </Center>
  )
}
